import axios from 'axios'
import cookie from 'vux/src/tools/cookie/index.js'
import querystring from 'vux/src/tools/querystring/index.js'

import Vue from 'vue'
import store from '@/store'
import Head from '@/plugins/headers.js'

if(!cookie.get('Authorization') && querystring.parse().jhu){
cookie.set('Authorization',querystring.parse().jhu)
}


let Authorization = cookie.get('Authorization')
let jhu = cookie.get('jhu')
if(Authorization){
if(/^dmp/.test(Authorization)){
Authorization = Authorization
}else{
Authorization = 'dmp ' + Authorization
}
}else if(jhu){
if(/^dmp/.test(jhu)){
Authorization = jhu
}else{
Authorization = 'dmp ' + jhu
}
}

function generateUUID() {
var d = new Date().getTime();
var uuid = 'xxxxxxxx-xxxx-yxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
function(c) {
var r = (d + Math.random() * 16) % 16 | 0;
d = Math.floor(d / 16);
return (c == 'x' ? r: (r & 0x3 | 0x8)).toString(16);
});
return uuid;
}

let headerList = Head(document.cookie);
let city_id = headerList.city_id,
app_key = headerList.app_key,
jid = headerList.jid,
app_version = headerList.app_version,
app_channel = headerList.app_channel,
pageId = headerList.pageId;

if (!jid || jid=='undefined') {
jid = generateUUID();
cookie.set('jid', jid, {
maxAge: 60000 * 60 * 24 * 365,
domain: ".jiehun.com.cn",
path: '/',
});
}

if(!pageId){
pageId = generateUUID();
cookie.set('page-id', pageId, {
path: '/'
});
}

let http = axios.create({
baseURL: process.env.API_HOST,
timeout: 15000,
headers: {
'Authorization':Authorization,
'city-id':city_id,
'app-key':app_key,
'app-version':app_version,
'app-channel':app_channel,
'client-id':jid,
'page-id':pageId
}
})


http.interceptors.request.use(config => {


let Authorization = cookie.get('Authorization')
let jhu = cookie.get('jhu')
if(Authorization){
if(/^dmp/.test(Authorization)){
Authorization = Authorization
}else{
Authorization = 'dmp ' + Authorization
}
}else if(jhu){
if(/^dmp/.test(jhu)){
Authorization = jhu
}else{
Authorization = 'dmp ' + jhu
}
}
config.headers['Authorization'] = Authorization;

return config
}, function (error) {

return Promise.reject(error);
})

http.interceptors.response.use(function (response) {
return response;
}, function (error) {

return Promise.reject(error);
});

export default {
get (url) {
return new Promise((resolve, reject) => {
http.get(url).then(res => {
resolve(res.data)
}).catch(error => {
if (error.response) {
resolve(error.response.data)
} else {
reject(error)
}
})
})
},
post (url, params) {
return new Promise((resolve, reject) => {

http.post(url, params).then(res => {
resolve(res.data)
}).catch(error => {

console.log('断网错误码',error)
Vue.$vux.toast.text('网络链接异常，请重试')
if (error.response) {
resolve(error.response.data)
} else {
reject(error)
}
})
})
}
}



// WEBPACK FOOTER //
// ./src/libs/http.js